<div class="how-it-works-card">
    <!-- Section Image/Vidéo Défilante -->
    <div class="video-preview-wrapper">
        <div class="image-slider">
            @for (img of images; track img; let i = $index) {
                <img [src]="img" 
                     [class.active]="currentImageIndex === i"
                     alt="How it works" 
                     class="preview-img">
            }
        </div>
        <div class="play-button" (click)="openHowItWorksVideo()">
            <i class="fas fa-play"></i>
        </div>
    </div>

    <!-- Contenu - Design professionnel comme l'image -->
    <div class="card-content app-download-section">
        <div class="content-inner">
            <!-- Cadre beige avec téléphone -->
            <div class="phone-container d-flex">
                <div class="phone-frame">
                    <div class="phone-screen">
                        <img src="assets/images/explore/app-home-screen.png" alt="Aperçu écran d'accueil YokaStar" class="app-home-screen-img" />
                    </div>
                </div>
                <div class="app-icons">
                        <p style="margin-bottom: 15px;margin-top: 20px;">
                            <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
                                <path
                                    d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                            </svg>
                            <span>
                                App Store
                            </span>
                        </p>
                        <p>
                            <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
                                <path
                                    d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                            </svg>
                             <span>
                                Play Store
                            </span>
                        </p>                     
                </div>
            </div>

            <h2 class="section-title">Installez l’application YokaStar</h2>
            <p class="section-description">
                Disponible sur Play Store et App Store pour une expérience mobile complète.
            </p>

            <!-- Bouton Télécharger - Ouvre le modal -->
            <button type="button" class="btn-download" (click)="openAppInstallModal()">
                Télécharger
            </button>
        </div>
    </div>
</div>
